import noop from 'lodash/noop'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

const createPostDataHook =
  (action, selector = noop) =>
  () => {
    const dispatch = useDispatch()
    const request = useCallback((...data) => (resolve, _reject) => {
      // Resolve on both success and error so the promise never hangs: success
      // returns the store data, error returns the error response (e.g. a 409)
      // so the caller can react instead of being stuck.
      const dispatchedAction = action(...data, (_a, _b, state) => {
        resolve(selector(state, data))
      })
      dispatchedAction.errorCallback = (errorResponse) => {
        resolve(errorResponse)
      }
      dispatch(dispatchedAction)
    })
    return [(...data) => new Promise(request(...data))]
  }

export default createPostDataHook
